import { useRuntimeConfig } from '#app'
import { useAuthStore } from '../stores/authStore'
import type { actionResponse } from '../types/cmsTypes'

export async function apiFetch(url: string, options?: RequestInit): Promise<actionResponse> {
  const config = useRuntimeConfig()
  const authstore = useAuthStore()
  try {
    const res = await fetch(`${config.public.apiBase}${url}`, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Charset': 'utf-8',
        ...(authstore.token ? { Authorization: `Bearer ${authstore.token}` } : {})
      },
      ...options
    })
    if (!res.ok) {
      const ct = res.headers.get('content-type') ?? ''
      const message = ct.includes('application/json')
        ? ((await res.json()).message ?? `http_${res.status}`)
        : ((await res.text()) || `http_${res.status}`)
      return { status_ok: false, message }
    }
    const data = await res.json().catch(() => null)
    return { status_ok: true, data }
  } catch {
    return { status_ok: false, message: 'network_error' }
  }
}

// api/core.ts
function buildAuthHeaders(): Record<string, string> {
  const authstore = useAuthStore()
  return authstore.token ? { Authorization: `Bearer ${authstore.token}` } : {}
}

export async function apiFetchBlob(url: string, options?: RequestInit): Promise<actionResponse> {
  const config = useRuntimeConfig()

  try {
    const res = await fetch(`${config.public.apiBase}${url}`, {
      ...options,
      headers: {
        Accept: 'application/octet-stream',
        ...buildAuthHeaders(),
        ...(options?.headers as Record<string, string> | undefined)
      }
    })

    if (!res.ok) {
      const message = (await res.text()) || `http_${res.status}`
      return { status_ok: false, message }
    }

    const blob = await res.blob()

    if (blob.size === 0) {
      return { status_ok: false, message: 'empty_file' }
    }

    return { status_ok: true, data: blob, filename: parseFilename(res) }
  } catch {
    return { status_ok: false, message: 'network_error' }
  }
}

function parseFilename(res: Response): string | undefined {
  const cd = res.headers.get('content-disposition')
  if (!cd) return undefined
  const utf8 = cd.match(/filename\*=UTF-8''([^;]+)/i)
  if (utf8) return decodeURIComponent(utf8[1] as string)
  const plain = cd.match(/filename="?([^";]+)"?/i)
  return plain?.[1]
}
